var map = {
	"./pc-module-promotion-1.vue": 66523,
	"./pc-module-promotion-10.vue": 57332,
	"./pc-module-promotion-11.vue": 56585,
	"./pc-module-promotion-2.vue": 3990,
	"./pc-module-promotion-3.vue": 77928,
	"./pc-module-promotion-4.vue": 38585,
	"./pc-module-promotion-5.vue": 60089,
	"./pc-module-promotion-6.vue": 14720,
	"./pc-module-promotion-7.vue": 84164,
	"./pc-module-promotion-8.vue": 87810,
	"./pc-module-promotion-9.vue": 70295
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48112;